import { render } from "./main_settings.html?vue&type=template&id=75fa6db6&external"
import script from "./main_settings.js?vue&type=script&lang=js&external"
export * from "./main_settings.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__